export const productionZonesHeaderElements = [
  { label: "Zona Productiva", value: "nombre" },
  { label: "Zona Comercial", value: "zonaComercial" },
  { label: "Estado", value: "activo" },
];
